import {
  takeEvery,
  put,
  call,
  all,
  takeLatest,
} from "redux-saga/effects";
import { toast } from "react-toastify";
// import { fetchMenuDataSuccess, fetchMenuDataFailure } from './usersSlice'; // Import your actions
import menuList from "../sample-data/menu.json";
import {
  fetchMenuDataSuccess,
  fetchMenuData as requestMenuRefresh,
  fetchReorderSuccess,
  generateOTPSuccess,
  loginSuccess,
  placeOrderSuccess,
  fetchBillSuccess,
  sendWaiterRequestSuccess,
} from "./action";
import {
  API_FETCH_MENU,
  GENERATE_LOGIN_OTP,
  SEND_LOGIN_OTP,
  REGISTER_USER,
  PLACE_ORDER,
  FETCH_REORDER_REQUEST,
  FETCH_BILL_REQUEST,
  SUBMIT_PAYMENT,
  SEND_WAITER_REQUEST,
} from "./constant";
import {
  fetchLogin,
  getMenuList,
  sendOtp,
  registerUser,
  apiPlaceOrder,
  getReorder,
  getBill,
  submitPayment,
  sendWaiterRequestAPI,
} from "./api";

// const fetchMenuDataSuccess = () => {}
const fetchMenuDataFailure = () => {};

function* logout() {
  localStorage.clear();
  sessionStorage.clear();
  yield put(generateOTPSuccess(false));
}

function* fetchMenuData(d) {
  console.log("API_FETCH_MENU called, so fetchMenuData", d);
  try {
    const url = `DisplayMenu`;
    const menuList = yield getMenuList(url, d.payload);
    console.log("menuList....", menuList);
    yield put(fetchMenuDataSuccess(menuList));
  } catch (error) {
    console.warn("Menu refresh failed; existing menu retained.", error.message);
  }
}

function* generateOTP(g) {
  console.log("GENERATE_LOGIN_OTP called, so generateOTP", g);

  try {
    const url = `SendOtp`;
    const response = yield sendOtp(url, g.payload);
    console.log("send otp....", response);
    yield put(generateOTPSuccess(true));
    toast.success("We has send the verification code to you via SMS");
  } catch (error) {
    toast.error("failed to send OTP");
    yield put(generateOTPSuccess(false));
  }
}

function* login(g) {
  console.log("SEND_LOGIN_OTP called, so generateOTP", g);
  try {
    const result = yield call(fetchLogin, "Verify-otp", g.payload);
    console.log("saga Login result:", result);

    if (result) {
      // User is registered, go to MENU
      yield put(loginSuccess({ redirectTo: "MENU", user: result }));
    } else {
      // User is not registered, go to REGISTER
      yield put(loginSuccess({ redirectTo: "REGISTER", user: null }));
    }
  } catch (error) {
    //toast.error('Invalid OTP');
    console.error(error);
  }
}

function* register(g) {
  console.log("REGISTER_USER called, so register", g);

  try {
    const url = `AddCustomerAndStartSession`;
    const result = yield registerUser(url, g.payload);
    console.log("register", result);
    yield put(loginSuccess({ redirectTo: "MENU", user: result }));
  } catch (error) {
    toast.error("Error while registation");
    // yield put(fetchMenuDataFailure(error));
  }
}

export function* placeOrder(g) {
  console.log("PLACE_ORDER called, so place order", g);

  try {
    const url = `PlaceOrder`;
    const result = yield apiPlaceOrder(url, g.payload);
    console.log("place order", result);

    yield put(placeOrderSuccess({ redirectTo: "MENU" }));
    toast.success("Order placed successfully");
  } catch (error) {
    console.log("error..........", error.message);
    if (error.status === 409) {
      toast.error(error.message);
      const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
      if (userInfo.restaurantId) yield put(requestMenuRefresh(userInfo.restaurantId));
      return;
    }
    if (
      error?.message === '"Invalid table OTP"' ||
      error === 'Error: "Invalid table OTP"'
    ) {
      toast.error("Invalid table OTP");
    } else {
      toast.error("Error while placing order");
    }
    // yield put(fetchMenuDataFailure(error));
  }
}

function* sendWaiterRequest(g) {
  console.log("sendWaiterRequest called, so waiter request", g);

  try {
    const url = `CreateServiceRequest`;
    const result = yield sendWaiterRequestAPI(url, g.payload);
    console.log("CreateServiceRequest", result);
    yield put(
      sendWaiterRequestSuccess({ redirectTo: "MENU", waiterRequest: result }),
    );
    toast.success("Successfully send messaged to waiter.");
  } catch (error) {
    console.log("error..........", error.message);
    //if (error?.message === '"Invalid table OTP"' || error === 'Error: "Invalid table OTP"') { toast.error('Invalid table OTP'); } else { toast.error('Error while placing order'); }
    // yield put(fetchMenuDataFailure(error));
  }
}

function* fatchReorder(g) {
  console.log("FETCH_REORDER_REQUEST called, so re-order", g);

  try {
    const url = `Re-Order`;
    const result = yield getReorder(url, g.payload);
    console.log("reorder", result);
    yield put(fetchReorderSuccess({ reorder: result }));
  } catch (error) {
    // yield put(fetchMenuDataFailure(error));
  }
}

function* fatchBill(g) {
  console.log("FETCH_BILL_REQUEST called, so re-order", g);

  try {
    const url = `GetBill`;
    const result = yield getBill(url, g.payload);
    console.log("GetBill", result);
    yield put(fetchBillSuccess(result));
  } catch (error) {
    // yield put(fetchMenuDataFailure(error));
  }
}

// function* payment(g) {
//   console.log('SUBMIT_PAYMENT called, so submit payment details', g);

//   try {
//     const url = `Payment`;
//     const result = yield submitPayment(url,g.payload)
//     console.log('place order', result);
//    // yield put(loginSuccess({ redirectTo: "MENU", user: result }));
//    // yield put(placeOrderSuccess({ redirectTo: "MENU", user: result }));
//    // toast.success('Order placed successfully');
//   } catch (error) {
//     toast.error('Error while verify payment');
//     // yield put(fetchMenuDataFailure(error));
//   }
// }

function* payment(action) {
  try {
    const { bill, billItems, billingType = 0 } = action.payload;
    const url = "SaveBillByCustomer";
    const response = yield call(
      submitPayment,
      url,
      bill,
      billItems,
      billingType,
    );

    toast.success(`Bill saved successfully`);
  } catch (error) {
    toast.error("Error while verify payment");
    //yield put({ type: SAVE_BILL_FAILURE, payload: error.message });
  }
}

// function* startSignalRToConfirmPaymentStatus(action) {
//   try {
//     const connection = yield call(createConnection);
// console.log("action.....",action)
//     // Wait until connection is started
//     yield call([connection, connection.start]);

//     connection.start()
//             .then(() => {
//                 console.log("Connected to SignalR!");

//                 // 3. Join the specific table session using the OTP
//                 connection.invoke("JoinTableSession", action.payload.tableOtp)
//                     .catch(err => console.error("Error joining session:", err));

//                 // 4. Listen for the "Settled" message
//                 connection.on("ReceiveBillStatus", (data) => {
//                     if (data.isPaid) {
//                        localStorage.removeItem("allInfo");
//                     }
//                 });
//             })
//             .catch(err => console.error("SignalR Connection Error: ", err));

//         // 5. CLEANUP: Close the connection when the user leaves the page
//         return () => {
//             if (connection) {
//                 connection.stop();
//                  window.location.href = "/thank-you";
//             }
//         };

//     // ✅ Correctly invoke JoinTable with GUID string + string
//     yield call(() =>
//       connection.invoke("JoinTable", String(action.payload.restaurantId), String(action.payload.tableNumber))
//     );

//     // Listen for server events
//     // connection.on("ReceiveBillStatus", () => {
//     //   sessionStorage.clear();
//     //   localStorage.clear();
//     //   window.location.href = "/thank-you";
//     // });

//     // connection.on("ReceiveNotification", (message) => {
//     //   console.log("Notification:", message);
//     // });
//   } catch (err) {
//     console.error("SignalR saga error:", err);
//   }
// }

{
  /**
 * Old implementation:

  function* userSaga() {
  // yield takeEvery('users/fetchMenuDataRequest', fetchMenuData);
  yield takeEvery(API_FETCH_MENU, fetchMenuData);
  }

  export default userSaga;

 */
}

function* watchSubmitPayment() {
  yield takeEvery(SUBMIT_PAYMENT, payment);
}

function* watchFetchReorder() {
  yield takeEvery(FETCH_REORDER_REQUEST, fatchReorder);
}

function* watchFetchMenu() {
  yield takeEvery(API_FETCH_MENU, fetchMenuData);
}

function* watchPlaceOrder() {
  yield takeEvery(PLACE_ORDER, placeOrder);
}

function* watchSendWaiterRequest() {
  yield takeEvery(SEND_WAITER_REQUEST, sendWaiterRequest);
}

function* watchGenerateLoginOTP() {
  yield takeEvery(GENERATE_LOGIN_OTP, generateOTP);
}

function* watchLoginOTPSubmit() {
  yield takeEvery(SEND_LOGIN_OTP, login);
}

function* watchRegistation() {
  yield takeEvery(REGISTER_USER, register);
}

function* watchFetchBill() {
  yield takeEvery(FETCH_BILL_REQUEST, fatchBill);
}

function* rootSaga() {
  yield all([
    watchFetchMenu(),
    watchGenerateLoginOTP(),
    watchLoginOTPSubmit(),
    watchRegistation(),
    watchPlaceOrder(),
    watchFetchReorder(),
    watchFetchBill(),
    watchSubmitPayment(),
    watchSendWaiterRequest(),
  ]);
}

export default rootSaga;

// ===== Later use dispatch to use it like =====
// import { useDispatch } from 'react-redux';
// import { fetchMenuData } from './usersSlice';

// const dispatch = useDispatch();

// const handlefetchMenuData = () => {
//   dispatch(fetchMenuData());
// };
